module.exports = __webpack_public_path__ + "img/Atif_Said.0a13a97e.png";